import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { UserProblem } from '@/types/UserProblem'

/**
 * The one way a failure the user cannot act on where they are reaches the screen.
 * It takes a problem rather than an error, so nothing can be reported without a fix.
 */
export const useErrorStore = defineStore('error', () => {
  const globalProblem = ref<UserProblem | undefined>()

  function reportProblem(problem: UserProblem): void {
    globalProblem.value = problem
  }

  function clearProblem(): void {
    globalProblem.value = undefined
  }

  return { globalProblem, reportProblem, clearProblem }
})
